<template>
  <v-container class="main-container responsive-height">
    <v-row>
      <v-col cols="12">
        <MiddleBar></MiddleBar>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" xl="12">
        <TransactionHistoryTab></TransactionHistoryTab>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MiddleBar from "@/components/PagesComponents/TransactionHistoryPage/MiddleBar.vue";
import TransactionHistoryTab from "@/components/PagesComponents/TransactionHistoryPage/TransactionHistoryTab.vue";
export default {
  data: () => ({
    forecast: [
      { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
      { day: "Withdraw", icon: "mdi-tray-arrow-up", links: "/withdraw" },
      { day: "Internal Trx.", icon: "mdi-swap-horizontal", links: "/internal-transfer" },
    ],
  }),
  components: {
    MiddleBar,
    TransactionHistoryTab
  },
};
</script>
